// src/dev/quiet-wds-logs.js
// Dev-only console filters to hide Webpack Dev Server /ws noise without changing behavior.
(function () {
  // Only act in development builds
  if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'development') return;

  const patternsError = [
    /WebSocket connection to 'ws:\/\/localhost:3000\/ws' failed/i,
    /Invalid frame header/i,
  ];
  const patternsInfo = [
    /Trying to reconnect/i, // from webpack-dev-server client
  ];

  const origError = console.error;
  const origInfo  = console.info;

  console.error = function (...args) {
    try {
      if (args.some(a => typeof a === 'string' && patternsError.some(p => p.test(a)))) {
        return; // swallow only the known WDS /ws errors
      }
    } catch {}
    return origError.apply(console, args);
  };

  console.info = function (...args) {
    try {
      if (args.some(a => typeof a === 'string' && patternsInfo.some(p => p.test(a)))) {
        return; // hide the "Trying to reconnect..." spam
      }
    } catch {}
    return origInfo.apply(console, args);
  };
})();
